// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-5224d5a3]{display:none}.tooltip-container[data-v-5224d5a3]{margin-left:11px}.review-number-container[data-v-5224d5a3]{margin-left:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
